var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_vm._v("born")]),_c('div',[_vm._v("artist: "+_vm._s(_vm.artist))]),_c('div',[_vm._v("name: "+_vm._s(_vm.name))]),_c('div',[_vm._v("location: "+_vm._s(_vm.location))]),_c('div',[_vm._v("date: "+_vm._s(_vm.date))]),_c('div',[_vm._v("description: "+_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }